let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("ketVE")).then(() => parcelRequire('kotdS'));